import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { DiagramsResponse } from '../models/shared/diagrams-response.model';

@Injectable({
  providedIn: 'root'
})
export class DiagramsService {
  baseUrl: string = this.configService.getConfig().apiBase + "/" + this.configService.getConfig().diagramsRoute;

  constructor(
    private http: HttpClient,
    private configService: ConfigService) {	}
  
    GetDiagrams$(submissionId: string): Observable<DiagramsResponse> {
      let url = this.baseUrl + "/" + submissionId + "/getDiagrams";
      let params = new HttpParams();
      if (this.configService.getConfig().apiMode) {
        params = params.set('mode', this.configService.getConfig().apiMode);
      }
      let headers = new HttpHeaders({
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      });
  
      return this.http.get<DiagramsResponse>(url, { params: params, headers: headers })
    }
}
